import { useMutation } from 'react-query'

import { getVerifyMyAgeUrl } from 'services/endpoints/verify'

export const useGetVerifyMyAgeUrl = () => {
    return useMutation(async () => await getVerifyMyAgeUrl())
}
